import axios from 'axios';
import { buildApiUrl, resolveMediaUrl } from '../utils/media';
import { extractListPayload, normalizeProduct, normalizeProducts } from '../utils/products';

const rawApiBase = process.env.REACT_APP_BACKEND_URL?.trim();
export const API = (rawApiBase || '').replace(/\/+$/, '');

if (!rawApiBase && typeof window !== 'undefined') {
  console.warn('REACT_APP_BACKEND_URL is not set. API requests will use relative paths unless you explicitly configure a backend base URL.');
}

export const apiClient = axios.create({
  baseURL: API || undefined,
  timeout: 15000,
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
  },
});
export { buildApiUrl, resolveMediaUrl, extractListPayload, normalizeProduct, normalizeProducts };

export function readSessionCache(key) {
  try {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch {
    sessionStorage.removeItem(key);
    return null;
  }
}

export function normalizeCmsImages(value) {
  if (Array.isArray(value)) {
    return value.map(normalizeCmsImages);
  }

  if (!value || typeof value !== 'object') {
    return value;
  }

  return Object.fromEntries(
    Object.entries(value).map(([key, entryValue]) => {
      const shouldResolve = /(?:image|url)$/i.test(key);
      return [key, shouldResolve ? resolveMediaUrl(entryValue) : normalizeCmsImages(entryValue)];
    })
  );
}
